import React from 'react';
import { connect } from 'react-redux';
import { Button, Accordion } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import textUtil from '../../util/text';
import { trackChartPointDetailsView } from '../../util/mixpanel';
import { isWhite } from '../../util/colors';
import { formatWorkDuration } from '../../util/dates';

export class FEDetailsAccordion extends React.Component {
  constructor(props) {
    super(props);

    if (props.test) {
      this.state = {
        show: true,
        data: this.props.data
      };
    } else {
      this.state = {
        show: false,
        data: {}
      };
    }

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        show: true,
        data: this.props.data
      });
    }
  }

  handleClose() {
    this.setState({
      show: false,
      data: {}
    });

    trackChartPointDetailsView('fe', false);
  }

  renderDetail(d, y, bl, blockedTime, label, blockers) {
    const blockedList = _.find(bl, { listId: d.listId });
    const blockedListTime = blockedList ? blockedList.blockedTime : 0;
    const calculatedListTime = blockedTime === 'non-blocked' ? d.cycleTime - blockedListTime : blockedTime === 'blocked' ? blockedListTime : d.cycleTime;
    const ct = formatWorkDuration(calculatedListTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays);
    const showBlockerInfo = blockers !== false && blockedTime === 'all';
    return (
      <p key={y}>
        {label}{' '}{d.list}: {ct}{' '}
        {showBlockerInfo && !!blockedList && (
          <span>
            {' '}
            {d.list} blocked time:{' '}
            {formatWorkDuration(blockedList.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}{' '}
          </span>
        )}{' '}
      </p>
    );
  }

  render() {
    const { show, data } = this.state;
    const { cards, efficiency } = data;
    const { blockedTime, blockers } = this.props;
    const showBlockerInfo = blockers !== false;
    const label = showBlockerInfo && blockedTime == 'blocked' ? 'Blocked ' : '';
    
    const cycleTime = data.cycleTime && `${data.cycleTime} ${data.cycleTime > 1 ? 'days': 'day'}`;

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        {!show || !cards ? (
          <div></div>
        ) : (
          <div id={this.props.id} className="box_white_shadow detailed_accordion">
            <div className='box_white_title mb-4'>
              <p>Flow efficiency: {efficiency}%</p>
              <div className='right-actions'>
                <Button className="btn-action" onClick={this.handleClose}>
                  &times;
                </Button>
              </div>
            </div>
          
            {cycleTime ? (<p>Cycle Time: {cycleTime}</p>) : (<p>Frequency: {cards.length}</p>)}

            <Accordion>
              {cards.map((card, i) => {
                return (
                  <Accordion.Item eventKey={i} key={i} activeKey={i === 0} className={showBlockerInfo && !!card.card.blockedTime && 'accordion-item-blocked-card'}>
                    <Accordion.Header>
                      <span className={`label_dot ${isWhite(card.color) ? 'label_dot--white' : ''}`} style={{ background: card.color }} />
                      {card.card.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      {!!card.card.secondaryName && <p>Summary: {card.card.secondaryName}</p>}
                      {!!card.card.coloredField && (
                        <p>
                          {textUtil.format(card.card.coloredField, null, false, false, 'capitalize')}:{' '}
                          {card.card.coloredValue}
                        </p>
                      )}
                      <p>
                        Cycle time:{' '}
                        {card.totalTime ?
                          formatWorkDuration(card.totalTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays):
                          formatWorkDuration(_.sumBy(card.details, 'cycleTime'), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
                      </p>
                      {showBlockerInfo && blockedTime === 'all' && !!card.card.blockedTime && (
                        <p className='block-item'>
                          Blocked time:{' '}
                          {formatWorkDuration(card.card.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
                        </p>
                      )}
                      {card.details.map((d, y) => {
                        return this.renderDetail(d, y, card.card.blockedLists, blockedTime, label, blockers);
                      })}
                      {!!card.card.url && (
                        <p>
                          <a href={card.card.url} target="_blank" className='btn btn-sm btn-light-secondary'>
                            Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
                          </a>
                        </p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(FEDetailsAccordion);
